import { mcpConnectionsEnUS } from "./mcp-connections/en-US";

export default {
  mcpConnections: mcpConnectionsEnUS,
  profile: "Profile",
  setup2FA: "Setup Two Factor Authentication",
  setup2FADescription:
    "Protect your account with an additional layer of security. Scan the QR code with your authenticator app or enter the code manually.",
  twoFactorQrCodeAlt: "Two factor authentication QR code",
  verifyTheCodeFromTheApp: "Verify the code from the app",
  verify: "Verify",
  connectedAccounts: "Connected Accounts",
  connect: "Connect",
  disconnect: "Disconnect",
  disconnectConfirmTitle: "Disconnect Account",
  disconnectConfirmMessage:
    "Are you sure you want to disconnect your {{provider}} account?",
};
